import React, {useState,useRef} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso, AddItemToList,ArticleBarSearch} from "@gull";
import axios from 'axios'
import swal from "sweetalert2"
import ModalSelectArticlePrice from "@gull/components/modal/ModalSelectArticlePrice"

const useLoadInit = () => {
    const t = useTranslate();
    const [loadingSearchItem,setLoadingSearchItem]=useState(false)
    const [listSearchItem,setListSearchItem]=useState([])
    const [datas,setDatas] = useState(listSearchItem)
    const searchInput = useRef('')

    const loadItems = async (inputValue) => {
        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/name/"+inputValue
        ).then((response) => {
            setLoadingSearchItem(false)
            setListSearchItem(response.data.datas)
            let ajour = response.data.datas.filter((value)=>value.name.replace(/\u00A0/g,' ').toLowerCase().includes(searchInput.current.value.replace(/\u00A0/g,' ').toLowerCase()))
            setDatas(ajour)
        }).catch((error) => {
            if(error=='end_session') return;
            setLoadingSearchItem(false)
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }
    
    return [loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput]
}

const FormulaireAjoutArticleSupplementList = (props) => {
    const t = useTranslate();
    const [loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput] = useLoadInit()
    const [showAccordion,setShowAccordion]=useState(false)

    const [inputScan,setInputScan]=useState('')
    const [showPriceModal,setShowPriceModal]=useState(false)
    const [pendingArticle,setPendingArticle]=useState(null)
    const [selectedPriceId,setSelectedPriceId]=useState(null)
    const [loadingModal,setLoadingModal]=useState(false)

    const handleSubmitArticleListe = async (obj,setValidButton,resetFiltreItemsToPromo,setShowModalAdd) =>{
        setValidButton(true)

        const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/supplement_list/add_item/"+props.supplementListId, obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else {
                props.setReload(Date.now())
                if(resetFiltreItemsToPromo) resetFiltreItemsToPromo()
                setValidButton(false)
                if(setShowModalAdd) setShowModalAdd(false)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError
            if(error.response==undefined){
                messageError='unknowError'
            }
            else if(error.response.status==403){
                messageError='forbiddenGeneral'
            }
            else {
                messageError='unknowError'
            }

            swal.fire(t(messageError), "", "error");
            setValidButton(false)
        })
    }

    const handleConfirmPrice = () => {
        const obj = {
            articles: [{ id: pendingArticle.id, article_price_id: selectedPriceId }]
        }
        handleSubmitArticleListe(obj, setLoadingModal, false, false)
        setShowPriceModal(false)
        setPendingArticle(null)
        setSelectedPriceId(null)
    }

    const addNewItem = async (e,articleid,inputname,articleBar) =>{//selection l'article dans l'input data
        let article = (e) ? e.target.value : articleid
        let urlArticle = (e) ? "api/erp/article/reference/" : "api/erp/article/one/"

        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+urlArticle+article
        ).then((response) => {
            if(response.data.hasOwnProperty('valid') && !response.data.valid){
                swal.fire(t('articleNoReferenceFind'), "", "error");
            }else{
                const articleData = (e) ? response.data.data.article : response.data.data
                setPendingArticle(articleData)
                setSelectedPriceId(null)
                setShowPriceModal(true)
                setInputScan('')
            }
            setLoadingSearchItem(false)
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
            setLoadingSearchItem(false)
        })
    }

    return (<>
        <ModalSelectArticlePrice
            show={showPriceModal}
            article={pendingArticle}
            selectedPriceId={selectedPriceId}
            onSelectPrice={setSelectedPriceId}
            onConfirm={handleConfirmPrice}
            onCancel={()=>{setShowPriceModal(false);setPendingArticle(null);setSelectedPriceId(null)}}
            loading={loadingModal}
        />
        <CardPerso header={<>
                <button
                    className="btn btn-sm btn-success"
                    onClick={()=>setShowAccordion(!showAccordion)}
                >
                    {t('addItemsMass')}
                </button>
            </>}>

            <div className="row">
                <div className="col-12 col-lg-4 form-group">
                    <label>{t('addItem')}</label>
                    <ArticleBarSearch 
                        loadingSearchItem={loadingSearchItem}
                        loadItems={loadItems}
                        listSearchItem={listSearchItem}
                        datas={datas}
                        setDatas={setDatas}
                        valueInput={inputScan}
                        setValueInput={setInputScan}
                        handleSubmit={addNewItem}
                        searchInput={searchInput}
                        noBlur={true}
                        icon='true'
                    />
                </div>
            </div>

            {(showAccordion) &&
                <>
                    <hr />
                    <AddItemToList 
                        liaisons={props.liaisons}
                        customFields={props.customFields} 
                        setToast={props.setToast}
                        customInterface={props.customInterface}
                        setCustomInterface={props.setCustomInterface}
                        setReload={props.setReload}

                        setShowAccordion={setShowAccordion}
                        articleListeId={props.supplementListId}//Id de la liste d'article
                        tableName={"baseAddItemToItemList"}
                        from='supplementList'
                        handleSubmitArticleListe={handleSubmitArticleListe}
                    />
                </>
            }
            
        </CardPerso>
    </>);
}

export default FormulaireAjoutArticleSupplementList;